/**
 * 최대화한 창이 하나라도 보이는 동안 `body[data-window-maximized="true"]` 를 단다.
 *
 * 최대화한 창은 창 평면을 꽉 채우는데 오른쪽 아래 상태 카드(`floatingActions`)는 그 위에
 * 고정으로 떠 있어 창 오른쪽 아래 글자를 가린다. 카드가 이 표시를 보고 한 줄로 접혀 창 아래
 * 바닥글 띠로 내려간다(퀘스트 5794f2cb). windowStore 는 최대화 상태를 모르므로 창이 직접
 * 알린다. 셈 방식은 `useModalA11y` 의 `data-modal-open` 과 같다 — 여러 창이 최대화돼 있으면
 * 마지막 하나가 풀릴 때 지운다.
 */
let maximizedWindowCount = 0;

export function markWindowMaximized(): () => void {
  maximizedWindowCount++;
  document.body.dataset.windowMaximized = 'true';
  return () => {
    maximizedWindowCount--;
    if (maximizedWindowCount === 0) delete document.body.dataset.windowMaximized;
  };
}
